import { TDispatch } from 'utils';

import { AppointmentMode } from '__generated__/globalTypes';
import { getAvailableCounsellors_availableCounsellors_counsellors } from './../../hooks';
import type {
  getServices_bookableServices_appointmentTypes,
  getServices_bookableServices as IService,
} from './../../../Book/hooks/useGetServices/__generated__/getServices';

import { ContactDetails, IContactDetails } from './../ContactDetails';
import { ConfirmDetails, IConfirmDetails } from './../ConfirmDetails';
import { Counsellor, ICounsellor } from './../Counsellor';
import { DateAndTime, IDateAndTime } from './../DateAndTime';
import { Preferences, IPreferences } from './../Preferences';
import { Summary } from './../Summary';

interface IErrors {
  [key: string]: string;
}

interface IAnswers {
  0: IContactDetails;
  1: IPreferences;
  2: IDateAndTime;
  3: ICounsellor;
  4: IConfirmDetails;
}

export interface IStep {
  dispatch: TDispatch;
  errors?: IErrors;
  service: IService;
  step: number;
  formData: IAnswers;
}

export const formSteps = [
  { component: ContactDetails, key: 0 },
  { component: Preferences, key: 1 },
  { component: DateAndTime, key: 2 },
  { component: Counsellor, key: 3 },
  { component: ConfirmDetails, key: 4 },
  { component: Summary, key: 5 },
] as const;
export type TSteps = typeof formSteps;

export interface IFormState {
  service: IService;
  step: 0 | 1 | 2 | 3 | 4 | 5;
  answers: IAnswers;
  details: {
    appointmentId?: string;
    appointmentMode?: AppointmentMode;
    appointmentTypes?: getServices_bookableServices_appointmentTypes[];
    counsellor: getAvailableCounsellors_availableCounsellors_counsellors | null;
    country?: string;
    phoneWithoutCallingCode?: string;
    submittedForm: boolean;
  };
  errors?: IErrors;
}
